import { IdentityProvidersState } from "@idw-types/state/identity-providers-state";
import { IdentityProvidersActionTypes, IdentityProvidersActions } from "../actions/identity-providers-actions";

export const initialIdentityProvidersState: IdentityProvidersState = {
    identityProviderConfigurations: {
        identityProviderConfigurations: null,
        isLoading: false
    },
    referenceData: {
        isLoading: false,
        categories: null,
        classifications: null,
        companies: null,
        loas: null,
        protocols: null
    }
};

export const identityProvidersReducer = (
    state: IdentityProvidersState = initialIdentityProvidersState,
    action: IdentityProvidersActions
): IdentityProvidersState => {
    switch (action.type) {
        // Reference Data
        case IdentityProvidersActionTypes.SET_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialIdentityProvidersState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case IdentityProvidersActionTypes.SET_IDENTITY_PROVIDERS_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        // Identity Providers
        case IdentityProvidersActionTypes.SET_IDENTITY_PROVIDER_CONFIGURATIONS_LOADING:
            return {
                ...state,
                identityProviderConfigurations: {
                    ...(action.payload.isLoading
                        ? { ...initialIdentityProvidersState.identityProviderConfigurations }
                        : { ...state.identityProviderConfigurations }),
                    isLoading: action.payload.isLoading
                }
            };
        case IdentityProvidersActionTypes.SET_IDENTITY_PROVIDER_CONFIGURATIONS:
            return {
                ...state,
                identityProviderConfigurations: {
                    identityProviderConfigurations: action.payload.identityProviderConfigurations,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};